import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DeclarationPromptData, DeclarationPromptService } from './declaration-prompt.service';

@Component({
  selector: 'app-declaration-prompt',
  templateUrl: './declaration-prompt.component.html',
  styleUrls: ['./declaration-prompt.component.scss']
})
export class DeclarationPromptComponent {
  @Input() promptData: DeclarationPromptData | null = null;
  @Output() dismissed = new EventEmitter<void>();
  isProcessing = false;

  constructor(private router: Router, private declarationService: DeclarationPromptService) {}

  async onYes(): Promise<void> {
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;
    let declarationStatusResponse: any;

    try {
      await this.declarationService.saveRelationshipStatus(true);
      declarationStatusResponse = await this.declarationService.checkFormDraft();
    } catch (error) {
      console.error('Failed to save relationship status for Yes:', error);
    } finally {
      this.isProcessing = false;
    }

    this.dismissed.emit();

    if (this.isDraftStatus(declarationStatusResponse)) {
      this.router.navigate(['declaration'], { state: { hasRelationship: true } });
    }
  }

  async onNo(): Promise<void> {
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;

    try {
      await this.declarationService.saveRelationshipStatus(false);
    } catch (error) {
      console.error('Failed to save relationship status for No:', error);
    } finally {
      this.isProcessing = false;
    }

    this.dismissed.emit();

    this.router.navigate(['declaration'], {
      fragment: 'employee-declaration',
      state: { hasRelationship: false }
    });
  }

  private isDraftStatus(response: any): boolean {
    return this.declarationService.getDeclarationFormStatus(response) === 'draft';
  }
}
